import { withLoader } from '@/components/atoms/Loader/withLoader';
import * as React from 'react';
import {
    GRID_ROW_ITEMS,
    ImageLibraryItem,
    ImageLibraryItemContainer,
    ImageLibraryItemText,
    ImageLibraryListContainer,
    ImagerLibraryRow,
} from '../ImageInput.style';
import { useImageInputVM } from '../ImageInput.viewmodel';
import { ImageInputProps } from '../ImageInput.interface';

const InnerLibraryGrid: React.FunctionComponent<LibraryGridProps> = ({
    virtualListRef,
    rowVirtualizer,
    value,
    libraryFiles,
    handleImageClick,
}) => {
    const rowVirtualizerItems = rowVirtualizer.getVirtualItems();
    const emptyGridRow = new Array(GRID_ROW_ITEMS).fill(0);

    return (
        <ImageLibraryListContainer ref={virtualListRef}>
            {rowVirtualizerItems.map(({ key, index, size, start }, rowIndex) => (
                <ImagerLibraryRow key={`image-library-row-${key}-${index}-${rowIndex}`} rowSize={size} rowStart={start}>
                    {emptyGridRow.map((_, columnIndex) => {
                        const file = libraryFiles[index * GRID_ROW_ITEMS + columnIndex];

                        if (!file) {
                            return null;
                        }
                        return (
                            <ImageLibraryItemContainer
                                key={`${file.filename}-${key}-${columnIndex}`}
                                data-testid={`image-library-item-container-${file.filename}-${key}-${columnIndex}`}
                            >
                                <ImageLibraryItem
                                    data-testid="imageInput-imageLibraryItem"
                                    data-selected={value === file.imageId}
                                    onClick={handleImageClick(file)}
                                >
                                    <img alt={file.originalFilename} src={file.fullUrl} />
                                </ImageLibraryItem>
                                <ImageLibraryItemText text={file.originalFilename} noTranslation />
                            </ImageLibraryItemContainer>
                        );
                    })}
                </ImagerLibraryRow>
            ))}
        </ImageLibraryListContainer>
    );
};

type LibraryGridProps = Pick<
    ReturnType<typeof useImageInputVM>,
    'rowVirtualizer' | 'virtualListRef' | 'libraryFiles' | 'handleImageClick'
> &
    Pick<ImageInputProps, 'value'>;

export const LibraryGrid = withLoader(InnerLibraryGrid);
